import styled from "@emotion/styled";
import UI from "@mile-meeting/mile-ui";
import { IconNames } from "@mile-meeting/mile-ui/dist/component/Icon/icon";

type ToolTipProps = {
  text: string | JSX.Element | undefined;
  position: {
    top?: number | string;
    left?: number | string;
  };
  icon?: IconNames | JSX.Element;
  zIndex?: number;
};
const ToolTip = ({ text, position, icon = "question", zIndex = 10 }: ToolTipProps) => {
  return (
    <Container style={{ zIndex: zIndex }}>
      {typeof icon === "string" && <UI.Icon name={icon} size={20} color="var(--alias-color-label-assistive)" />}
      {typeof icon !== "string" && icon}
      {text && (
        <ToolTipContainer
          className="tooltip"
          style={{
            position: "absolute",
            top: position.top ?? 0,
            left: position.left ?? 0,
          }}
        >
          <UI.Typography type="label01" fontStyle="medium" color="var(--global-color-common-100)">
            {text}
          </UI.Typography>
        </ToolTipContainer>
      )}
    </Container>
  );
};

export default ToolTip;

const Container = styled.div`
  position: relative;
  align-items: center;
  display: flex;
  z-index: 10;

  .tooltip {
    display: none;
  }

  &:hover {
    .tooltip {
      display: flex;
    }
  }
`;

const ToolTipContainer = styled.div`
  padding: 2px 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: max-content;

  border-radius: 4px;
  background-color: rgba(24, 26, 27, 0.6);
`;
